module.exports = __webpack_public_path__ + "static/img/znsj_05.724e1e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/znsj_05.png
// module id = 1Nvt
// module chunks = 15